import React, { useContext } from "react";

import { UserContext } from "@/components/User";

import { OnboardingProfileTypeSelect } from "../components/ProfileTypeSelect";
import { OnboardingManageProfile } from "./OnboardingManageProfile";

interface IOnboardingProps {
  children: React.ReactElement;
}

export const Onboarding: React.FC<IOnboardingProps> = React.memo(props => {
  const User = useContext(UserContext);

  if (User.sessionUser.consultantProfiles.length > 0 && User.contextConsultantProfileId === undefined) {
    return <OnboardingManageProfile />;
  }

  if (!User.sessionUser.onboardingDisplayed || !User.contextConsultantProfileId) {
    return <OnboardingProfileTypeSelect />;
  }

  return props.children;
});
